import React, { Component } from 'react'
import styled from 'styled-components'

export default class ButtonCompareMobileV2 extends Component {
  handleClick = (e) => {
    const { onClick, setModalTriggerHeight } = this.props

    onClick && onClick(e)
    if (setModalTriggerHeight) {
      setModalTriggerHeight(this.buttonRef.getBoundingClientRect().top)
    }
  }

  render() {
    return (
      <CompareButton
        innerRef={(ref) => (this.buttonRef = ref)}
        {...this.props}
        onClick={this.handleClick}>
        Comparar
      </CompareButton>
    )
  }
}

const CompareButton = styled.button.attrs({ ref: (props) => props.buttonRef })`
  outline: none;
  border: none;
  background-color: transparent;

  cursor: pointer;

  color: #006736;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */

  &:disabled {
    color: #bababa;
    cursor: default;
  }
`



// WEBPACK FOOTER //
// ./src/components/ButtonCompareMobileV2/index.js